import Vue from 'vue'
import WidgetApi from '../apis/widget'
export const state = () => ({
  token: "",
  url: "",
  name: "",
  id: "",
});
export const actions = {
  async copy({ commit, state }) {
    return await WidgetApi.copy(state)
  },
}
export const mutations = {
  setToken(state, token){
    state.token = token
  },
  setUrl(state, url){
    state.url = url
  },
  setName(state, name){
    state.name = name
  },
  setId(state, id){
    state.id = id
  }
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
